export enum SelectionDataType {
  objectList,
  unknownType,
  stringList
}
